import { render, staticRenderFns } from "./OpinionPostModal.vue?vue&type=template&id=8f4b7c9e&"
import script from "./OpinionPostModal.vue?vue&type=script&lang=ts&"
export * from "./OpinionPostModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports